import styled from 'styled-components';
import './../style.css'
import './../css/bootstrap.css'
import './../css/dark.css'
import './../css/font-icons.css'
import './../css/components/ion.rangeslider.css'
import './../css/custom.css'
import './../css/fonts.css'

const Styles = styled.div`


ul{
    list-style-type:none;
    display: flex;
}
li{
    display: flex;
    padding: 0;
}
.descriptions{
    display: flex;
    flex-direction: column;
}
.descriptions>span{
    font-size: 14px;
}
.selected{
	background-color: #0e6786 !important;
	color: #FFFFFF;
	border-color: #FFFFFF;
}
`
const QuizStepDisplay = props => {
    const { step, question } = props;

    return <Styles>
        <div class="content-wrap">
			<div class="container">
                <ul className="process-steps row col-mb-30">
                    {['Mapeamento da empresa', 'S&OP', 'S&OE', 'Resultado'].map((title, index) => {
                        return (
                            <li key={index} className={`col-sm-3`}>
                                <a href="#ptab1" className={`i-circled i-bordered i-alt mx-auto ${title === step.title ? 'selected' : ''}`}>{index + 1}</a>
                                <div className="descriptions">
                                <h5>{title}</h5>
                                {title === step.title && question && <span>{question.dimension}</span>}
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    </Styles>
}

export default QuizStepDisplay;
